export default function FaqHero({ leftMedia, rightMedia }) {
    return (<section className="faq-hero">
        {leftMedia && (
            <img
                src={leftMedia}
                alt="FAQ decoration left"
                className="faq-decor left"
                loading="lazy"
            />
        )}

        <div className="faq-content">
            <h1>How can we help you today?</h1>
            <p>Browse our most frequently asked questions.</p>
        </div>

        {rightMedia && (
            <img
                src={rightMedia}
                alt="FAQ decoration right"
                className="faq-decor right"
                loading="lazy"
            />
        )}
    </section>

    )
}
